{
  "Accessibility Menu": "Menu Truy cập",
  "Reset settings": "Đặt lại cài đặt",
  "Close": "Đóng",
  "Content Adjustments": "Điều chỉnh Nội dung",
  "Adjust Font Size": "Điều chỉnh Kích thước Font chữ",
  "Highlight Title": "Đánh dấu Tiêu đề",
  "Highlight Links": "Đánh dấu Liên kết",
  "Readable Font": "Font chữ Dễ đọc",
  "Color Adjustments": "Điều chỉnh Màu sắc",
  "Dark Contrast": "Tương phản Tối",
  "Light Contrast": "Tương phản Sáng",
  "High Contrast": "Tương phản Cao",
  "High Saturation": "Bão hòa Cao",
  "Low Saturation": "Bão hòa Thấp",
  "Monochrome": "Đơn sắc",
  "Tools": "Công cụ",
  "Reading Guide": "Hướng dẫn Đọc",
  "Stop Animations": "Dừng Hoạt hình",
  "Big Cursor": "Con trỏ Lớn",
  "Increase Font Size": "Tăng Kích thước Font chữ",
  "Decrease Font Size": "Giảm Kích thước Font chữ",
  "Letter Spacing": "Khoảng cách Chữ",
  "Line Height": "Độ Cao dòng",
  "Font Weight": "Độ Đậm của Font chữ",
  "Dyslexia Font": "Font chữ Cho người có Khuyết tật đọc hiểu",
  "Language": "Ngôn ngữ",
  "Open Accessibility Menu": "Mở Menu Truy cập"
}
